import PropTypes from 'prop-types';

import './headingContainer.scss';

const HeadingContainer = ({ children }) => {
  return <div className="iw__heading-container">{children}</div>;
};

export default HeadingContainer;

HeadingContainer.propTypes = {
  children: PropTypes.node.isRequired,
};
